import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class CaptchaGenStatEditDto extends IdentifiableDto {
	constructor() {
		super();
		/** @type {string} */
		this.profileNames = null;
		/** @type {string} */
		this.captchaTypeEngineName = null;
		/** @type {string} */
		this.captchaTypeEngineParams = null;
		/** @type {number} */
		this.numberOfGenerated = null;
		/** @type {number} */
		this.minimumGenerationTime = null;
		/** @type {number} */
		this.averageGenerationTime = null;
		/** @type {number} */
		this.maximumGenerationTime = null;
	}

	/**
	 * @typedef {Object} _CaptchaGenStatEditDtoProps
	 * @property {string} profileNames
	 * @property {string} captchaTypeEngineName
	 * @property {string} captchaTypeEngineParams
	 * @property {number} numberOfGenerated
	 * @property {number} minimumGenerationTime
	 * @property {number} averageGenerationTime
	 * @property {number} maximumGenerationTime
	 * @typedef {import("../NamedDto").NamedDtoProps & _CaptchaGenStatEditDtoProps} CaptchaGenStatEditDtoProps
	 */
	/**
	 *
	 * @param {CaptchaGenStatEditDtoProps} props
	 * @returns {CaptchaGenStatEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.profileNames = props.profileNames;
		this.captchaTypeEngineName = props.captchaTypeEngineName;
		this.captchaTypeEngineParams = props.captchaTypeEngineParams;
		this.numberOfGenerated = props.numberOfGenerated;
		this.minimumGenerationTime = props.minimumGenerationTime;
		this.averageGenerationTime = props.averageGenerationTime;
		this.maximumGenerationTime = props.maximumGenerationTime;
		return this;
	}
}

export default CaptchaGenStatEditDto;
